(function(){
  'use strict';
  /* klaviyoCompany is the public site ID that already ships in the klaviyo.js src on every page;
     it is a publishable key, not a secret. klaviyoList is "Email List", the list the welcome flow
     triggers on. Both are needed by subscribe() below. */
  var CFG={delay:8000,productDelay:45000,homeDelay:15000,pdpDelay:7000,cookie:'opt_wp_v14',days:30,code:'PERSONAL10',pct:'10%',
           klaviyoCompany:'RxDDxH',klaviyoList:'SVwvmA'};
  var BASE='https://optistasis.store/products/'; /* 2026-09-19: personal codes (Klaviyo PERSONAL10) arrive by email, so this button no longer applies a shared code */
  var P={drops:'lymphatic-drainage-drops-traditional-circulatory-support-59ml',
         duo:'complete-the-ritual-de-puff-duo'};

  /* One question. Its answer is the Klaviyo property, the Shopify tag and the product pick. */
  var QUESTIONS=[
    {k:'concern', prop:'Main Concern', t:'What brings you here?', o:[
      {v:'puffy-face',label:'Puffy face in the mornings'},
      {v:'heavy-legs',label:'Heavy or swollen legs by evening'},
      {v:'bloating',  label:'Bloating and fluid retention'},
      {v:'arms',      label:'Heavy or swollen arms'},
      {v:'browsing',  label:'Just browsing for now'}]}
  ];

  /* Concerns carry the routing: which product, which Shopify tag, what the property reads.
     They no longer carry copy — three voices do, below. */
  var CONCERNS={
    'puffy-face':{label:'Morning facial puffiness',tag:'concern-face',product:P.duo,ctaKey:'duo'},
    'heavy-legs':{label:'Heavy or swollen legs',tag:'concern-legs',product:P.drops,ctaKey:'drops'},
    'bloating'  :{label:'Bloating and fluid retention',tag:'concern-bloat',product:P.drops,ctaKey:'drops'},
    'arms'      :{label:'Heavy or swollen arms',tag:'concern-arms',product:P.drops,ctaKey:'drops'},
    'browsing'  :{label:'Just browsing',tag:'concern-browsing',product:P.drops,ctaKey:'drops'},
    'skipped'   :{label:'Skipped',tag:'concern-unknown',product:P.drops,ctaKey:'drops'}
  };

  /* ── THE FINAL SCREEN, THREE WAYS ──────────────────────────────────────────────
     One visitor sees one voice, picked at random and remembered, and the letter rides along
     on every event and on the profile as "Copy Variant". That is the whole A/B rig: compare
     Scratch Offer Revealed and Scratch Shop Clicked by variant in Klaviyo, and read placed
     orders against the profile property.

     Rules all three obey: never print the amount, never print the code, never claim more than
     supporting lymphatic flow. {email} is filled in at render time.

       A  Mechanism   explains what is happening in the body. Nearest to the original copy.
       B  The moment  anchors to a time of day the reader recognises in themselves.
       C  Short       dry and clipped, fastest to read on a phone.
     ──────────────────────────────────────────────────────────────────────────── */
  var VOICES={
    A:{name:'Mechanism',
       hed:'Check your inbox.',
       sent:'We sent your personal code to {email}.', sentNone:'Your personal code is on its way.',
       fine:'It is yours alone and works once, within 14 days.',
       cta:{duo:'Shop the De-Puff Duo',drops:'Shop the Drops'},
       rec:{
        'puffy-face':'Lymph pools in your face while you sleep, which is why mornings look worst. The De-Puff Duo pairs the Drops with the Sculpt Brush, the tool for draining the face.',
        'heavy-legs':'Your legs have been working against gravity since breakfast. By evening you feel it. The Drops support the flow that clears it.',
        'bloating'  :'Fluid retention comes down to drainage. Start with the Drops.',
        'arms'      :'Lymph from your arms drains up toward the armpit, and it only moves when you do. Still arms let fluid settle. The Drops support that flow.',
        'browsing'  :'Take your time. Most start with the Drops: four herbs, under the tongue, once or twice a day.',
        'skipped'   :'The Drops are where most people start: four herbs, under the tongue, once or twice a day.'}},

    B:{name:'The moment',
       hed:'It is on its way.',
       sent:'Your personal code is heading to {email}.', sentNone:'Your personal code is on its way.',
       fine:'Made for you, and only you. It works once.',
       cta:{duo:'Start with the Duo',drops:'Start with the Drops'},
       rec:{
        'puffy-face':'Tomorrow at 7am, the mirror. That is the one you want to change. The De-Puff Duo adds the Sculpt Brush so you can work the face directly.',
        'heavy-legs':'Six o’clock, and your shoes stopped fitting an hour ago. The Drops support the flow that moves it.',
        'bloating'  :'Your waistband tells you before the scale does. The Drops support daily drainage.',
        'arms'      :'Sleeves that felt fine this morning feel tight by evening. Lymph moves when your muscles do, and the Drops support that flow.',
        'browsing'  :'No rush. When you are ready, the Drops are the place to start: four herbs, under the tongue, once a day.',
        'skipped'   :'Start where most people do. The Drops: four herbs, under the tongue, once a day.'}},

    C:{name:'Short',
       hed:'Sent.',
       sent:'Your personal code is on its way to {email}.', sentNone:'Your personal code is on its way.',
       fine:'Yours alone. One use. 14 days.',
       cta:{duo:'Get the Duo',drops:'Get the Drops'},
       rec:{
        'puffy-face':'Face first, every morning. The De-Puff Duo adds the Sculpt Brush so you can work it directly.',
        'heavy-legs':'Gravity wins by evening. The Drops support the flow that pushes back.',
        'bloating'  :'Usually drainage. Start with the Drops.',
        'arms'      :'Still arms, slow lymph. The Drops support daily flow.',
        'browsing'  :'Fair enough. The Drops when you are ready: four herbs, under the tongue, daily.',
        'skipped'   :'The Drops are the place to start. Four herbs, under the tongue, daily.'}}
  };

  /* Sticky per browser, so someone who reopens the popup does not get a different voice
     mid-decision and land in two buckets. localStorage throws in some privacy modes, so every
     touch is guarded and a failure just means a fresh random pick. */
  var VKEYS=['A','B','C'];
  var VARIANT=(function(){
    var pick=VKEYS[Math.floor(Math.random()*VKEYS.length)];
    try{
      var saved=window.localStorage.getItem('opt_wp_variant');
      if(saved&&VOICES[saved]) return saved;
      window.localStorage.setItem('opt_wp_variant',pick);
    }catch(e){}
    return pick;
  })();
  function voice(){ return VOICES[VARIANT]||VOICES.A; }
  function variantLabel(){ return VARIANT+' · '+voice().name; }

  /* ?showpopup=1 forces the popup open for testing, ignoring the 30-day cookie. Declared here,
     BEFORE setCookie and the cookie gate that both read it. */
  var FORCE = window.location.search.indexOf('showpopup=1') > -1;
  /* v20 (2026-09-24) — owner: "only 1 per session, and after sign up it won't pop up".
     Before this the only memory was the 30-day cookie written on CLOSE, so a visitor who signed
     up and tapped Shop (or left the page with the popup open) saw it again on the next page.
       opt_wp_s   session cookie, written when the popup OPENS: at most once per browser session.
       opt_wp_sub 10-year cookie + localStorage, written on a valid email submit: never again.
       __kla_id   Klaviyo's own cookie; if it already carries an email or an email-click id, the
                  visitor is on the list (arrived from one of our emails), so skip.
     ?showpopup=1 still bypasses all of these for testing. */
  var SESS='opt_wp_s', SUBD='opt_wp_sub';
  function hasC(n){return document.cookie.split(';').some(function(c){return c.trim().indexOf(n+'=')===0;});}
  function markSession(){if(FORCE) return;document.cookie=SESS+'=1;path=/;SameSite=Lax';}
  function markSubscribed(){if(FORCE) return;var d=new Date();d.setTime(d.getTime()+3650*86400000);document.cookie=SUBD+'=1;expires='+d.toUTCString()+';path=/;SameSite=Lax';try{window.localStorage.setItem(SUBD,'1');}catch(e){}}
  function knownSubscriber(){
    if(hasC(SUBD)) return true;
    try{ if(window.localStorage.getItem(SUBD)) return true; }catch(e){}
    try{ var k=(document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/)||[])[1];
      if(k){ var o=JSON.parse(atob(decodeURIComponent(k))); if(o&&(o.$email||o.$exchange_id)) return true; } }catch(e){}
    return false;
  }
  function hasCookie(){return hasC(CFG.cookie)||hasC(SESS)||knownSubscriber();}
  function setCookie(){if(FORCE) return;var d=new Date();d.setTime(d.getTime()+CFG.days*86400000);document.cookie=CFG.cookie+'=1;expires='+d.toUTCString()+';path=/;SameSite=Lax';}
  function isEmail(v){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);}

  /* Every event carries the copy variant, so the whole funnel splits by it without any event
     needing to remember to pass it: shown, revealed, submitted, shop clicked. */
  function track(n,p){p=p||{};
    try{p['Copy Variant']=variantLabel();}catch(e){}
    try{if(window.klaviyo&&window.klaviyo.push)window.klaviyo.push(['track',n,p]);}catch(e){}
    try{if(window.dataLayer&&window.dataLayer.push)window.dataLayer.push(Object.assign({event:n.replace(/\s+/g,'_').toLowerCase()},p));}catch(e){}
    publishShopify(n,p);}
  /* Shopify customer events: popup funnel for a custom pixel (Settings > Customer events) to forward
     to GA4. Klaviyo cannot count views: it drops events from visitors it does not know yet, so
     "Scratch Popup Shown" there undercounts. These events fire for US visitors ONLY.
     The country is the visitor's IP country from /browsing_context_suggestions.json. Shopify.country
     cannot be used: this store has one market, so it reads "US" for everyone (it said US for a
     visitor in Malaysia). Looked up on the popup's first event, once per tab session; events wait in a queue until it answers,
     and are dropped if the lookup fails, so nothing unconfirmed is counted. */
  var SHOPIFY_EVENTS={'Scratch Popup Shown':'optistasis_popup_shown','Scratch Email Submitted':'optistasis_popup_email_submitted','Scratch Subscribed':'optistasis_popup_subscribed'};
  var usQueue=[], usState=null; /* null = unknown, true = US, false = not US / lookup failed */
  function sendShopify(n,p){try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish(SHOPIFY_EVENTS[n],p);}catch(e){}}
  function setUS(v){usState=v;var q=usQueue;usQueue=[];if(v)q.forEach(function(a){sendShopify(a[0],a[1]);});}
  function publishShopify(n,p){
    if(!SHOPIFY_EVENTS[n]||usState===false) return;
    var d={};for(var k in p)d[k]=p[k];d.Country='US';
    if(usState) sendShopify(n,d); else {usQueue.push([n,d]);lookupCountry();}
  }
  var lookedUp=false;
  function lookupCountry(){
    if(lookedUp) return; lookedUp=true;
    var cached=null;try{cached=window.sessionStorage.getItem('opt_wp_country');}catch(e){}
    if(cached){setUS(cached==='US');return;}
    fetch('/browsing_context_suggestions.json',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(j){
      var c=j&&j.detected_values&&j.detected_values.country&&j.detected_values.country.handle||'';
      try{if(c)window.sessionStorage.setItem('opt_wp_country',c);}catch(e){}
      setUS(c==='US');
    }).catch(function(){setUS(false);});
  }
  function identify(p){try{if(window.klaviyo&&window.klaviyo.push)window.klaviyo.push(['identify',p]);}catch(e){}}

  /* Subscribe through Klaviyo's client endpoint, and treat THIS as the thing that has to succeed.
     identify() alone is not a signup: it writes properties and leaves consent NEVER_SUBSCRIBED with
     no list membership, so the welcome flow — which triggers on being added to a list — never runs.
     Measured on a live submit: identify() alone gave NEVER_SUBSCRIBED; this call gives SUBSCRIBED
     with a consent timestamp and fires "Subscribed to List".

     The Shopify customer form still posts alongside this, for the Shopify-side customer record and
     its tags. It cannot be relied on for the email: Shopify's bot protection cancels every form
     submit on the page, binds an invisible captcha and re-submits, so the outcome is neither
     synchronous nor observable from here. Delivery of the code must not depend on it. */
  function subscribe(email,props){
    var attrs={email:email,properties:props};
    /* v22 — a hung request must end in the error state, not in an endless "Sending…". */
    var ac=('AbortController' in window)?new AbortController():null;
    if(ac) setTimeout(function(){ac.abort();},10000);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(CFG.klaviyoCompany),{
      method:'POST',
      headers:{'Content-Type':'application/json',revision:'2024-10-15'},
      signal:ac?ac.signal:undefined,
      body:JSON.stringify({data:{type:'subscription',
        attributes:{custom_source:'Scratch Card Popup',profile:{data:{type:'profile',attributes:attrs}}},
        relationships:{list:{data:{type:'list',id:CFG.klaviyoList}}}}})
    }).then(function(r){
      if(!r.ok) throw new Error('klaviyo '+r.status);
      return true;
    });
  }

  var path=window.location.pathname;
  /* ?showpopup=1 forces it open for testing, ignoring the 30-day cookie. Without this the only
     way to see it again after closing it once is to clear the cookie or use a private window,
     which makes "it isn't showing" very easy to misdiagnose. Exclusions below still apply. */
  if(!FORCE && hasCookie()) return;
  /* Deliberate exclusions, all by decision:
       /checkout, /cart   would interrupt a purchase already in progress
       /account           these visitors are customers with an address on file already
       *quiz*             /pages/store-quiz and /pages/advertorial-quiz already run this quiz,
                          so the popup would compete with the thing the visitor came to do
       *advertorial*      /pages/advertorial-{beer,education,guasha,quiz} and /pages/advertorials
                          are paid-traffic landing pages with their own single call to action
     Matching on the substring rather than an exact list means a new advertorial or quiz page is
     excluded automatically. Delete a term to show the popup there. */
  var EXCLUDE=['/checkout','/cart','/account','quiz','advertorial'];
  for(var xi=0; xi<EXCLUDE.length; xi++){ if(path.indexOf(EXCLUDE[xi])>-1) return; }

  var popup=document.getElementById('opt-wp');
  if(!popup) return;
  /* v21 (2026-09-24) — owner: never show to logged-in customers. The snippet marks #opt-wp with
     data-customer="1" when Shopify renders the page for a signed-in customer account.
     ?showpopup=1 still forces it for testing. */
  if(!FORCE && popup.getAttribute('data-customer')) return;
  var eyebrow=document.getElementById('opt-wp-eyebrow'),
      hed=document.getElementById('opt-wp-hed'),
      sub=document.getElementById('opt-wp-sub'),
      hint=document.getElementById('opt-wp-hint'),
      claimCta=document.getElementById('opt-wp-claimcta'),
      claimBtn=document.getElementById('opt-wp-claim-btn'),
      main=document.getElementById('opt-wp-main'),
      qStep=document.getElementById('opt-wp-question'),
      qCount=document.getElementById('opt-wp-qcount'),
      qTitle=document.getElementById('opt-wp-qtitle'),
      qOpts=document.getElementById('opt-wp-qopts'),
      qProg=document.getElementById('opt-wp-progbar'),
      backBtn=document.getElementById('opt-wp-back'),
      eStep=document.getElementById('opt-wp-emailstep'),
      emailEl=document.getElementById('opt-wp-email'),
      emailSub=document.getElementById('opt-wp-emailsub'),
      tagsEl=document.getElementById('opt-wp-tags'),
      xBtn=document.getElementById('opt-wp-x'),
      errMsg=document.getElementById('opt-wp-errmsg'),
      sent=document.getElementById('opt-wp-sent'),
      sentEmail=document.getElementById('opt-wp-sent-email'),
      sentHed=document.getElementById('opt-wp-sent-hed'),
      sentFine=document.getElementById('opt-wp-sent-fine'),
      recEl=document.getElementById('opt-wp-rec'),
      shopBtn=document.getElementById('opt-wp-shop'),
      reward=document.getElementById('opt-sc-reward'),
      live=document.getElementById('opt-wp-live'),
      box=popup.querySelector('.opt-wp-box');
  /* 2026-10-26 — on the Halloween offer page (?view=lp2) the scratch card gets Halloween copy, an "lp2-halloween"
     Shopify tag and an "LP2 Halloween" Klaviyo profile property, and the last screen leads back to the bundles.
     Everywhere else is unchanged. (Replaces the 2026-10-24 early-access copy.) */
  var BF_EARLY = /[?&]view=lp2(&|$)/.test(window.location.search);
  if(BF_EARLY){
    var bfEb=document.getElementById('opt-wp-eyebrow'), bfHd=document.getElementById('opt-wp-hed'), bfSb=document.getElementById('opt-wp-sub');
    if(bfEb) bfEb.textContent='Early Black Friday';
    if(bfHd) bfHd.textContent='Scratch for 10% off your first order';
    if(bfSb) bfSb.textContent='Your code works once, within 14 days. The early Black Friday sale ends Thursday, November 26.';
    if(tagsEl) tagsEl.value=tagsEl.value+',lp2-halloween';
  }
  /* 2026-11-03 — owner: on normal pages the scratch card is "your unique gift is waiting for you"
     and the email (Klaviyo flow Wb5xgK) opens the Buy 1 Get 1 sale page. The profile property
     Gift Page Access=Yes routes the signup into that flow and out of the welcome flow UKVsQ7.
     Ends with the sale; after that this whole branch is off and the 10% card is back. */
  var GIFT = !BF_EARLY && Date.now() < Date.parse('2026-11-27T04:59:00Z');
  if(GIFT){
    var gEb=document.getElementById('opt-wp-eyebrow'), gHd=document.getElementById('opt-wp-hed'), gSb=document.getElementById('opt-wp-sub'),
        gUn=popup.querySelector('.opt-sc-unlocked'), gSm=document.getElementById('opt-wp-submit');
    if(gEb) gEb.textContent='A gift for you';
    if(gHd) gHd.textContent='Your unique gift is waiting for you';
    if(gSb) gSb.textContent='Drag across the foil to unwrap it.';
    if(gUn) gUn.textContent='Your unique gift';
    if(claimBtn) claimBtn.innerHTML='Claim my gift &rarr;';
    if(gSm) gSm.textContent='Send my gift';
    if(tagsEl) tagsEl.value=tagsEl.value+',bf-gift';
  }
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var answers={}, qIndex=0, capturedEmail='', shown=false;
  function say(m){if(live)live.textContent=m;}

  /* v20 — never open over the cart drawer: a shopper who adds to cart before the timer fires
     would get the scratch card on top of Secure Checkout. Wait until the drawer closes, then
     give them a moment before opening. */
  function cartOpen(){var d=document.querySelector('cart-drawer');return !!(d&&d.classList.contains('active'));}
  var waitingCart=false;
  function waitForCart(){
    if(waitingCart) return; waitingCart=true;
    var d=document.querySelector('cart-drawer');
    var mo=new MutationObserver(function(){
      if(d.classList.contains('active')) return;
      mo.disconnect(); waitingCart=false;
      setTimeout(function(){ if(FORCE||!hasCookie()) openPopup(); },1500);
    });
    mo.observe(d,{attributes:true,attributeFilter:['class']});
  }
  function openPopup(){
    if(shown) return;
    if(cartOpen()){ waitForCart(); return; }
    shown=true; markSession();
    popup.classList.add('opt-wp-on');
    track('Scratch Popup Shown');
    setTimeout(initCanvas,80);
    setTimeout(function(){ var r=document.getElementById('opt-wp-reveal'); if(r) try{r.focus({preventScroll:true});}catch(e){r.focus();} },120);
  }
  function closePopup(){
    popup.classList.remove('opt-wp-on'); setCookie();
    setTimeout(function(){if(popup.parentNode)popup.parentNode.removeChild(popup);},380);
  }
  popup.addEventListener('click',function(e){if(e.target===popup)closePopup();});
  document.addEventListener('keydown',function(e){
    if(!popup.classList.contains('opt-wp-on')) return;
    if(e.key==='Escape'){closePopup();return;}
    if(e.key!=='Tab') return;
    var f=box.querySelectorAll('button,[href],input:not([type=hidden]),select,textarea');
    f=Array.prototype.filter.call(f,function(el){return el.offsetParent!==null;});
    if(!f.length) return;
    var first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
  xBtn.addEventListener('click',closePopup);
  /* lets the offer page open the card on demand (?view=lp2 only) */
  if(BF_EARLY) window.optOpenEarlyAccess=function(){
    if(!popup.parentNode||popup.getAttribute('data-customer')||knownSubscriber()) return false;
    shown=false; openPopup(); return true;
  };

  /* ── STEP 1 · the foil ──────────────────────────────────────── */
  function initCanvas(){
    var cv=document.getElementById('opt-sc-cv');
    if(!cv||cv.dataset.ready) return;
    cv.dataset.ready='1';
    var ctx=cv.getContext('2d'),wrap=cv.parentElement,r=wrap.getBoundingClientRect();
    var dpr=Math.min(window.devicePixelRatio||1,2);
    cv.width=Math.round((r.width||300)*dpr); cv.height=Math.round((r.height||148)*dpr);
    ctx.scale(dpr,dpr);
    var W=(r.width||300),H=(r.height||148);
    if(reduce){cv.style.display='none';revealNow();return;}
    paintFoil(ctx,W,H);

    var RADIUS=20,down=false,px=0,py=0,cnt=0,done=false;
    function scratchAt(x,y){
      var grd=ctx.createRadialGradient(x,y,0,x,y,RADIUS);
      grd.addColorStop(0,'rgba(0,0,0,1)');grd.addColorStop(.5,'rgba(0,0,0,.9)');grd.addColorStop(1,'rgba(0,0,0,0)');
      ctx.globalCompositeOperation='destination-out';ctx.fillStyle=grd;
      ctx.beginPath();ctx.arc(x,y,RADIUS,0,Math.PI*2);ctx.fill();
    }
    function scratchLine(x1,y1,x2,y2){
      var d=Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1)),steps=Math.max(1,Math.floor(d/6));
      for(var i=0;i<=steps;i++){var t=i/steps;scratchAt(x1+(x2-x1)*t,y1+(y2-y1)*t);}
    }
    function getPos(e){var rc=cv.getBoundingClientRect(),s=e.touches?e.touches[0]:e;
      return{x:(s.clientX-rc.left)*(W/rc.width),y:(s.clientY-rc.top)*(H/rc.height)};}
    function onMove(e){if(!down||done)return;e.preventDefault();var p=getPos(e);scratchLine(px,py,p.x,p.y);px=p.x;py=p.y;if(++cnt%8===0)checkCoverage();}
    function onStart(e){e.preventDefault();down=true;var p=getPos(e);px=p.x;py=p.y;scratchAt(p.x,p.y);}
    function checkCoverage(){var d=ctx.getImageData(0,0,cv.width,cv.height).data,clr=0,tot=0;
      for(var i=3;i<d.length;i+=4*24){tot++;if(d[i]<128)clr++;}
      if(clr/tot>.45){done=true;autoReveal();}}
    function autoReveal(){
      cv.style.transition='opacity .45s ease';cv.style.opacity='0';
      if(reward)reward.classList.add('rv');
      setTimeout(function(){if(cv.parentNode)cv.style.display='none';showUnlocked();},440);
    }
    cv.addEventListener('mousedown',onStart,{passive:false});
    cv.addEventListener('mousemove',onMove,{passive:false});
    cv.addEventListener('mouseup',function(){down=false;},{passive:true});
    cv.addEventListener('mouseleave',function(){down=false;},{passive:true});
    cv.addEventListener('touchstart',onStart,{passive:false});
    cv.addEventListener('touchmove',onMove,{passive:false});
    cv.addEventListener('touchend',function(){down=false;},{passive:true});
  }
  function paintFoil(ctx,W,H){
    var g=ctx.createLinearGradient(0,0,W,H);
    g.addColorStop(0,'#c9a54a');g.addColorStop(.3,'#b38c26');g.addColorStop(.62,'#d6b264');g.addColorStop(1,'#966c1e');
    ctx.fillStyle=g;ctx.fillRect(0,0,W,H);
    ctx.save();ctx.strokeStyle='rgba(255,248,190,.07)';ctx.lineWidth=1;
    for(var i=-H;i<W+H;i+=7){ctx.beginPath();ctx.moveTo(i,0);ctx.lineTo(i+H,H);ctx.stroke();}
    ctx.restore();
    ctx.save();
    ctx.translate(W/2,H/2);ctx.rotate(-Math.PI/9);ctx.translate(-W/2,-H/2);
    ctx.fillStyle='rgba(255,250,225,.16)';
    ctx.font='600 10px '+(getComputedStyle(document.body).fontFamily||'sans-serif');
    ctx.textBaseline='middle';
    for(var row=-1;row<Math.ceil(H/26)+2;row++){
      var off=(row%2)?-52:0;
      for(var col=-1;col<Math.ceil(W/104)+2;col++){ctx.fillText('OPTISTASIS',off+col*104,row*26);}
    }
    ctx.restore();
  }
  var unlocked=false;
  function revealNow(){if(reward)reward.classList.add('rv');showUnlocked();}
  /* v22 — the foil only responds to dragging. This button reveals the same thing for keyboard
     and switch users, and for anyone who would rather not scratch. */
  var revealBtn=document.getElementById('opt-wp-reveal');
  if(revealBtn) revealBtn.addEventListener('click',function(){
    var cv=document.getElementById('opt-sc-cv'); if(cv) cv.style.display='none';
    track('Scratch Revealed By Button'); revealNow();
  });

  /* ── STEP 2 · unlocked, amount still hidden ─────────────────── */
  function showUnlocked(){
    if(unlocked) return; unlocked=true;
    track('Scratch Revealed');
    /* 2026-09-19 "Almost yours" copy, owner pick after a competitor/best-practice review.
       Rules it follows: say the discount is guaranteed and show how little is left; never
       "up to", "??%", "you won" or "lucky" (every visitor gets the same 10%, so implied odds
       are an FTC deception risk); the amount stays off screen because it arrives by email. */
    eyebrow.textContent='1 question left';
    hed.textContent='Your welcome discount is ready.';
    sub.textContent='One quick question, then it\u2019s in your inbox.';
    sub.style.display='';
    hint.style.display='none';
    claimCta.style.display='block'; claimCta.classList.add('opt-wp-fade');
    say('Your welcome discount is ready. One quick question, then it is in your inbox.');
    if(GIFT){ hed.textContent='Your unique gift is ready.'; sub.textContent='One quick question, then we send it to your inbox.';
      say('Your unique gift is ready. One quick question, then we send it to your inbox.'); }
    if(claimBtn&&!reduce) setTimeout(function(){claimBtn.focus();},120);
  }
  claimBtn.addEventListener('click',function(){
    track('Scratch Claim Clicked'); showQuestion();
  });

  /* ── STEP 3 · the quiz ────────────────────────────────────── */
  function showQuestion(){
    main.style.display='none'; eStep.style.display='none'; sent.style.display='none';
    qStep.style.display='block';
    renderQuestion();
  }
  function renderQuestion(){
    var q=QUESTIONS[qIndex];
    qCount.textContent = QUESTIONS.length>1 ? 'Question '+(qIndex+1)+' of '+QUESTIONS.length : 'One quick question';
    qTitle.textContent=q.t;
    qProg.parentElement.style.display = QUESTIONS.length>1 ? '' : 'none';
    backBtn.style.display = qIndex>0 ? 'block' : 'none';
    qOpts.innerHTML='';
    q.o.forEach(function(opt,i){
      var b=document.createElement('button');
      b.type='button'; b.className='opt-wp-q'+(!reduce?' opt-wp-qin':'');
      if(!reduce) b.style.animationDelay=(40+i*38)+'ms';
      b.appendChild(document.createTextNode(opt.label));
      var ar=document.createElement('span');
      ar.className='opt-wp-arrow'; ar.setAttribute('aria-hidden','true');
      ar.innerHTML='&#8594;';
      b.appendChild(ar);
      b.addEventListener('click',function(){ answer(q,opt); });
      qOpts.appendChild(b);
    });
    say(q.t);
    var first=qOpts.querySelector('.opt-wp-q');
    if(first&&!reduce) setTimeout(function(){first.focus();},260);
  }
  function answer(q,opt){
    answers[q.k]=opt.v;
    /* the concern is the one answer that also tags the Shopify customer */
    if(q.k==='concern'){
      var c=CONCERNS[opt.v]||CONCERNS.skipped;
      if(tagsEl) tagsEl.value='newsletter,scratch-winner,'+c.tag;
    }
    qIndex++;
    if(qIndex>=QUESTIONS.length){
      track('Scratch Question Answered',{Concern:concernLabel()});
      setTimeout(showEmail,160);
    } else {
      setTimeout(renderQuestion,140);
    }
  }
  backBtn.addEventListener('click',function(){
    if(qIndex>0){ qIndex--; renderQuestion(); }
  });
  document.getElementById('opt-wp-skip').addEventListener('click',function(){
    track('Scratch Question Skipped');
    showEmail();
  });
  function concernLabel(){ return (CONCERNS[answers.concern]||CONCERNS.skipped).label; }
  function goal(){ return CONCERNS[answers.concern]||CONCERNS.skipped; }

  /* ── STEP 4 · email ─────────────────────────────────────────── */
  function showEmail(){
    qStep.style.display='none'; main.style.display='none';
    eStep.style.display='block'; eStep.classList.add('opt-wp-fade');
    if(emailSub){
      emailSub.textContent=GIFT?'Your unique gift is waiting. Add your email and we will send it to you now.'
                               :'Your offer is waiting. Add your email and we will unlock it now.';
    }
    track('Scratch Email Shown',{Concern:concernLabel()});
    say('Last step. Enter your email to unlock your offer.');
    if(emailEl&&!reduce) setTimeout(function(){emailEl.focus();},120);
  }

  var cform=document.getElementById('opt-wp-cform'),sink=document.getElementById('opt-wp-sink');
  var submitBtn=document.getElementById('opt-wp-submit'), sendErr=document.getElementById('opt-wp-senderr');
  var submitLabel=submitBtn?submitBtn.textContent:'';
  var pending=false;
  function busy(on){ if(!submitBtn) return; submitBtn.disabled=on; submitBtn.textContent=on?'Sending\u2026':submitLabel; }
  if(cform){
    if(sink) cform.target='opt-wp-sink';
    /* v22 — after the first post, Shopify's bot protection holds this form and a second click
       fires no submit event at all (measured). So a retry after a failed subscribe skips the
       native form (the Shopify customer record was already posted once) and calls the handler. */
    var attempted=false;
    if(submitBtn) submitBtn.addEventListener('click',function(e){
      if(!attempted) return;
      e.preventDefault(); handle(e);
    });
    cform.addEventListener('submit',handle);
    function handle(e){
      var v=emailEl?emailEl.value.trim():'';
      if(!isEmail(v)){e.preventDefault();emailEl.classList.add('opt-wp-ierr');
        if(errMsg)errMsg.style.display='block';emailEl.focus();return;}
      emailEl.classList.remove('opt-wp-ierr');
      if(errMsg)errMsg.style.display='none';
      if(sendErr) sendErr.style.display='none';
      capturedEmail=v;
      if(pending)return; pending=true; attempted=true; busy(true);
      /* Copy Variant lands on the profile too, not only on events, so orders placed weeks later
         can still be read back against the voice that won the signup. */
      var custom={'Signup Source':'Scratch Card Popup','Copy Variant':variantLabel()};
      if(BF_EARLY){ custom['LP2 Halloween']='Yes'; custom['LP2 Halloween Joined']=new Date().toISOString().slice(0,10); }
      if(GIFT){ custom['Gift Page Access']='Yes'; custom['Gift Page Joined']=new Date().toISOString().slice(0,10); custom['Gift Flow']='v2'; }
      /* Main Concern is the exact button text the visitor clicked ("Puffy face in the mornings"),
         or "Skipped" when they press Skip (set 2026-09-18 at the owner's request). The welcome
         emails print it only for a real concern: they exclude "Skipped" and "Just browsing for
         now" and show a generic line instead. Routing, Shopify tags and analytics events still
         use the internal key and the label in CONCERNS, so none of those change. */
      QUESTIONS.forEach(function(q){
        var val=answers[q.k], opt=null;
        q.o.forEach(function(o){ if(o.v===val) opt=o; });
        custom[q.prop] = opt ? opt.label : 'Skipped';
      });
      var props={'$email':v}; for(var k in custom) props[k]=custom[k];
      identify(props);
      track('Scratch Email Submitted',{Concern:concernLabel()});

      /* v22 — "Check your inbox" is shown only after Klaviyo accepts the subscription. Before
         this, an error or a 4 s timer also advanced to success, so a visitor whose signup failed
         was told a code was on its way. Now a failure keeps them on this step with a retry. */
      subscribe(v,custom).then(function(){
        pending=false; busy(false); markSubscribed();
        track('Scratch Subscribed',{Concern:concernLabel()});
        showFinal();
      }).catch(function(err){
        pending=false; busy(false);
        track('Scratch Subscribe Failed',{Concern:concernLabel(),Reason:String(err&&err.name==='AbortError'?'timeout':(err&&err.message||err))});
        if(sendErr) sendErr.style.display='block';
        say('We could not save your email. Please try again.');
        if(submitBtn) submitBtn.focus();
      });
    }
  }

  /* ── STEP 5 · the offer. The amount lands here; the CODE does not.
        The code is delivered by email, which is what makes the address worth giving.
        The Shop button carries the auto-apply discount link, so the visitor can act
        immediately without waiting for the inbox. ─────────────────── */
  function showFinal(){
    eStep.style.display='none'; qStep.style.display='none'; main.style.display='none';
    var g=goal(), V=voice(), key=answers.concern&&CONCERNS[answers.concern]?answers.concern:'skipped';
    if(sentHed) sentHed.textContent=V.hed;
    if(sentEmail) sentEmail.textContent = capturedEmail
      ? V.sent.replace('{email}',capturedEmail)
      : V.sentNone;
    if(recEl) recEl.textContent=V.rec[key];
    if(shopBtn){shopBtn.href=BASE+g.product;shopBtn.textContent=V.cta[g.ctaKey];}
    if(sentFine) sentFine.textContent=V.fine;
    if(BF_EARLY){
      if(sentFine) sentFine.textContent='Your 10% code works once, within 14 days. The early Black Friday sale ends Thursday, November 26, at 11:59 pm ET.';
      if(shopBtn){ shopBtn.href='#bf-sale'; shopBtn.textContent='Back to the bundles';
        shopBtn.addEventListener('click',function(e){ e.preventDefault(); closePopup(); var t=document.getElementById('bf-sale'); if(t) t.scrollIntoView({behavior:'smooth'}); }); }
    }
    if(GIFT){
      var gSe=sent.querySelector('.opt-wp-eyebrow'); if(gSe) gSe.textContent='Your unique gift';
      if(sentEmail) sentEmail.textContent = capturedEmail ? 'Your unique gift is on its way to '+capturedEmail+'.' : 'Your unique gift is on its way.';
      if(sentFine) sentFine.textContent='Open the email to unwrap it. Your gift ends Thursday, November 26.';
      if(shopBtn){ shopBtn.href='#'; shopBtn.textContent='Keep browsing';
        shopBtn.addEventListener('click',function(e){ e.preventDefault(); closePopup(); }); }
    }
    sent.style.display='block'; sent.classList.add('opt-wp-fade');
    track('Scratch Offer Revealed',{Concern:concernLabel(),Discount:GIFT?'gift page':CFG.pct,Code:GIFT?'none':CFG.code});
    say(GIFT?'Your unique gift has been emailed to you.':'Your personal code has been emailed to you. It works once, within 14 days.');
  }
  if(shopBtn) shopBtn.addEventListener('click',function(){track('Scratch Shop Clicked');});

  /* v15 — product pages never get the 8 s timed open: a paid visitor landing on the buy box
     must not lose it to a scratch card. Desktop product pages wait for exit intent only; touch
     product pages open at CFG.productDelay or once half the page has been scrolled, whichever
     comes first. Every other page keeps CFG.delay. ?showpopup=1 still opens at CFG.delay. */
  var onProduct=path.indexOf('/products/')>-1, touch=('ontouchstart' in window);
  /* v16 — the 45 s timer and the 50% scroll trigger both fired while a mobile visitor was
     still reading, and this popup covers 100% of the viewport at z-index 999999, including
     the sticky Add-to-Cart bar. Measured: the CTA became unclickable (elementFromPoint at the
     button centre returned #opt-wp). Touch product pages now open only once the visitor has
     effectively reached the end of the page, and the timer is gone. Desktop is unchanged:
     exit intent only. Every other template keeps CFG.delay. */
  /* v17 — v16 left desktop product pages with exit intent ONLY, so refreshing the page
     showed nothing at all and the popup felt broken/random. Desktop now gets a predictable
     timer (CFG.productDelay, 45 s) as well as exit intent, whichever comes first — long
     enough that a paid visitor landing on the buy box is not ambushed, but guaranteed to
     fire. Touch product pages keep the v16 end-of-page rule: this popup covers 100% of the
     viewport at z-index 999999, so on a phone it must never open while the sticky
     Add-to-Cart bar is still in play. Every other template keeps CFG.delay. */
  /* v18 (2026-09-08) — the homepage hero was being covered too.
     Measured as a genuine first-time visitor: on the homepage this popup opened over the
     headline, subhead and the only CTA, 8 s after landing — the same failure we fixed on the
     product page in v16, just on the page that receives the paid traffic first. The homepage
     is also where the entry CTA now sits above the fold on mobile, so an 8 s takeover lands
     exactly as the visitor is deciding.
     The homepage now waits for a sign of engagement: 30% scroll depth (past the hero and into
     the content) or CFG.productDelay, whichever comes first. Product pages keep the v16/v17
     rules. Every other template keeps the plain CFG.delay timer. ?showpopup=1 still opens
     immediately for testing. */
  var onHome = (path === '/' || path === '' || /^\/(index)?$/.test(path));
  /* v22 (2026-09-26) — holdout test for paid traffic on product pages (conversion re-audit #1).
     A paid visitor (click id or paid utm_medium on the landing URL, remembered for the tab
     session) is assigned once per browser, 50/50:
       control  the v19 rules below (7 s timer, 50% scroll on touch, exit intent on desktop)
       hold     no timer and no scroll trigger on product pages; desktop keeps exit intent
     The arm is written to the cart as the hidden attribute _opt_popup_pdp (it appears on the
     order's additional details, not at checkout) and published as a Shopify customer event, so
     purchase rate and revenue per visitor can be compared by arm. Organic visitors are not
     enrolled. To end the test, set PDP_TEST to false (everyone returns to control). */
  var PDP_TEST=true;
  function paidSession(){
    try{ if(window.sessionStorage.getItem('opt_paid')==='1') return true; }catch(e){}
    var q=window.location.search, paid=/[?&](gclid|gbraid|wbraid|fbclid|ttclid|msclkid|epik|sccid)=/.test(q)||
      /[?&]utm_medium=(cpc|ppc|paid|paidsocial|paid_social|paid-social|display|social_paid)(&|$)/i.test(q);
    if(paid){ try{window.sessionStorage.setItem('opt_paid','1');}catch(e){} }
    return paid;
  }
  function pdpArm(){
    var a=null; try{a=window.localStorage.getItem('opt_wp_pdp_arm');}catch(e){}
    if(a!=='hold'&&a!=='control'){ a=Math.random()<0.5?'hold':'control'; try{window.localStorage.setItem('opt_wp_pdp_arm',a);}catch(e){} }
    var mark='opt_wp_pdp_rec';
    if(!hasC(mark)){
      document.cookie=mark+'=1;path=/;SameSite=Lax';
      try{ fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes:{'_opt_popup_pdp':a}})}); }catch(e){}
      try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish('optistasis_popup_pdp_arm',{arm:a}); }catch(e){}
    }
    return a;
  }
  var isPaid = paidSession(); /* called on every page so a paid landing on the homepage is remembered */
  /* 2026-10-23 — the offer page (?view=lp2) always gets the scratch card: it is a list-building page,
     so its visitors are not enrolled in the holdout. */
  var onOfferPage = /[?&]view=lp2(&|$)/.test(window.location.search);
  var holdPdp = !FORCE && onProduct && !onOfferPage && PDP_TEST && isPaid && pdpArm()==='hold';
  /* 2026-10-28 — on the offer page (?view=lp2) the 7 s product-page clock starts at the visitor's first
     scroll, tap or key press instead of at page load, so the card never covers the page before anyone has
     looked at it (it also stopped speed tests from reading the page as still loading at ~8 s). */
  function optPdpTimer(fn){
    if(!onOfferPage) return setTimeout(fn, CFG.pdpDelay);
    var ev=['scroll','pointerdown','touchstart','keydown'], t=null;
    function go(){ ev.forEach(function(n){ window.removeEventListener(n,go,true); }); if(t===null) t=setTimeout(fn, CFG.pdpDelay); }
    ev.forEach(function(n){ window.addEventListener(n,go,{capture:true,passive:true}); });
    return null;
  }
  if(FORCE){ setTimeout(openPopup,CFG.delay); }
  else if(holdPdp){ /* hold arm: no timed or scroll-triggered open here; exit intent below still applies on desktop */ }
  /* 2026-11-02 — homepage timer 45 s -> 15 s (CFG.homeDelay) for Black Friday traffic; the 30% scroll
     trigger is unchanged. 8 s covered the hero in v18, so 15 s is the floor here. */
  else if(onHome){
    var homeTimer = setTimeout(openPopup, CFG.homeDelay);
    window.addEventListener('scroll',function hs(){
      var h=document.documentElement, seen=(h.scrollTop+window.innerHeight)/h.scrollHeight;
      if(seen>=0.30&&!shown){ clearTimeout(homeTimer); openPopup(); window.removeEventListener('scroll',hs); }
    },{passive:true});
  }
  else if(!onProduct){ setTimeout(openPopup,CFG.delay); }
  /* v19 (2026-09-17) — product pages open quicker, on request. Both desktop and
     touch now open at CFG.pdpDelay (7 s); touch also opens at 50% scroll, and
     desktop keeps exit intent. Homepage uses CFG.homeDelay (15 s since 2026-11-02). */
  else if(touch){
    var pdpTimer = optPdpTimer(function(){ if(!hasCookie()&&!shown) openPopup(); });
    window.addEventListener('scroll',function s(){
      var h=document.documentElement, seen=(h.scrollTop+window.innerHeight)/h.scrollHeight;
      if(seen>=0.50&&!shown&&!hasCookie()){clearTimeout(pdpTimer);openPopup();window.removeEventListener('scroll',s);}
    },{passive:true});
  }
  else { optPdpTimer(function(){ if(!hasCookie()&&!shown) openPopup(); }); }
  if(!touch){
    document.addEventListener('mouseleave',function h(e){
      if(e.clientY<=0&&!hasCookie()&&!shown){openPopup();document.removeEventListener('mouseleave',h);}
    });
  }
})();


